import { MapUtils } from "../../../../../core/MapUtils";
export class LinesController {
  constructor(_shader_name) {
    this._shader_name = _shader_name;
    this._definitionsByNodeId = /* @__PURE__ */ new Map();
    this._bodyLinesByNodeId = /* @__PURE__ */ new Map();
  }
  get shader_name() {
    return this._shader_name;
  }
  addDefinitions(node, definitions) {
    this._addDefinitionsForNodeId(node.graphNodeId(), definitions);
  }
  _addDefinitionsForNodeId(nodeId, definitions) {
    for (let definition of definitions) {
      MapUtils.pushOnArrayAtEntry(this._definitionsByNodeId, nodeId, definition);
    }
  }
  definitions(node) {
    return this._definitionsByNodeId.get(node.graphNodeId());
  }
  traverseDefinitions(callback) {
    this._definitionsByNodeId.forEach((definitions) => {
      for (let definition of definitions) {
        callback(definition);
      }
    });
  }
  addBodyLines(node, lines, options) {
    this._addBodyLinesForNodeId(node.graphNodeId(), lines);
  }
  _addBodyLinesForNodeId(nodeId, lines, options) {
    let makeUniq = true;
    if (options && options.makeUniq != null) {
      makeUniq = options.makeUniq;
    }
    const linesToUsed = [];
    if (makeUniq) {
      const currentLines = this._bodyLinesByNodeId.get(nodeId);
      for (let line of lines) {
        if (currentLines) {
          if (!currentLines.includes(line)) {
            linesToUsed.push(line);
          }
        } else {
          linesToUsed.push(line);
        }
      }
    } else {
      for (let line of lines) {
        linesToUsed.push(line);
      }
    }
    for (let line of linesToUsed) {
      MapUtils.pushOnArrayAtEntry(this._bodyLinesByNodeId, nodeId, line);
    }
  }
  bodyLines(node) {
    return this._bodyLinesByNodeId.get(node.graphNodeId());
  }
}
